var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoCard4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_4132_28651",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 62,
    height: 60,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7,
    y: 7,
    width: 62,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9882 12.2099H47.4584C47.1304 10.6106 45.7044 9.40336 44 9.40336H31.2941C29.5897 9.40336 28.1637 10.6106 27.8357 12.2099H24.3059C21.9317 12.2099 20 14.1298 20 16.4898V57.0439C20 59.4038 21.9317 61.3239 24.3059 61.3239H50.9882C53.3624 61.3239 55.2941 59.4038 55.2941 57.0439V16.4898C55.2941 14.1298 53.3624 12.2099 50.9882 12.2099ZM31.2941 10.8066H44C45.1677 10.8066 46.1176 11.7509 46.1176 12.9115C46.1176 14.0721 45.1677 15.0164 44 15.0164H31.2941C30.1263 15.0164 29.1765 14.0721 29.1765 12.9115C29.1765 11.7509 30.1263 10.8066 31.2941 10.8066ZM53.8823 57.0439C53.8823 58.6302 52.5841 59.9206 50.9882 59.9206H24.3059C22.71 59.9206 21.4118 58.6302 21.4118 57.0439V16.4898C21.4118 14.9036 22.71 13.6131 24.3059 13.6131H27.8357C28.1637 15.2124 29.5897 16.4196 31.2941 16.4196H44C45.7044 16.4196 47.1304 15.2124 47.4584 13.6131H50.9882C52.5841 13.6131 53.8823 14.9036 53.8823 16.4898V57.0439Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7059 27.2949H35.5294V29.7506C35.5294 30.138 35.8454 30.4522 36.2353 30.4522H39.7647C40.1546 30.4522 40.4706 30.138 40.4706 29.7506V27.2949H43.2941C43.684 27.2949 44 26.9807 44 26.5932V23.0851C44 22.6976 43.684 22.3835 43.2941 22.3835H40.4706V19.9278C40.4706 19.5403 40.1546 19.2261 39.7647 19.2261H36.2353C35.8454 19.2261 35.5294 19.5403 35.5294 19.9278V22.3835H32.7059C32.316 22.3835 32 22.6976 32 23.0851V26.5932C32 26.9807 32.316 27.2949 32.7059 27.2949ZM33.4118 23.7867H36.2353C36.6252 23.7867 36.9412 23.4725 36.9412 23.0851V20.6294H39.0588V23.0851C39.0588 23.4725 39.3748 23.7867 39.7647 23.7867H42.5882V25.8916H39.7647C39.3748 25.8916 39.0588 26.2058 39.0588 26.5932V29.0489H36.9412V26.5932C36.9412 26.2058 36.6252 25.8916 36.2353 25.8916H33.4118V23.7867Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3529 35.3635H37.6471C38.037 35.3635 38.3529 35.0494 38.3529 34.6619C38.3529 34.2745 38.037 33.9603 37.6471 33.9603H26.3529C25.963 33.9603 25.6471 34.2745 25.6471 34.6619C25.6471 35.0494 25.963 35.3635 26.3529 35.3635Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 38.1701H26.3529C25.963 38.1701 25.6471 38.4842 25.6471 38.8717C25.6471 39.2593 25.963 39.5734 26.3529 39.5734H48.9412C49.3311 39.5734 49.6471 39.2593 49.6471 38.8717C49.6471 38.4842 49.3311 38.1701 48.9412 38.1701Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 42.3797H26.3529C25.963 42.3797 25.6471 42.6938 25.6471 43.0813C25.6471 43.4689 25.963 43.783 26.3529 43.783H48.9412C49.3311 43.783 49.6471 43.4689 49.6471 43.0813C49.6471 42.6938 49.3311 42.3797 48.9412 42.3797Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 46.5895H26.3529C25.963 46.5895 25.6471 46.9036 25.6471 47.2912C25.6471 47.6787 25.963 47.9928 26.3529 47.9928H48.9412C49.3311 47.9928 49.6471 47.6787 49.6471 47.2912C49.6471 46.9036 49.3311 46.5895 48.9412 46.5895Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 50.7994H26.3529C25.963 50.7994 25.6471 51.1134 25.6471 51.501C25.6471 51.8886 25.963 52.2026 26.3529 52.2026H48.9412C49.3311 52.2026 49.6471 51.8886 49.6471 51.501C49.6471 51.1134 49.3311 50.7994 48.9412 50.7994Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 55.0092H26.3529C25.963 55.0092 25.6471 55.3232 25.6471 55.7108C25.6471 56.0984 25.963 56.4125 26.3529 56.4125H48.9412C49.3311 56.4125 49.6471 56.0984 49.6471 55.7108C49.6471 55.3232 49.3311 55.0092 48.9412 55.0092Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7647 15.0163C61.4294 15.0163 59.5294 16.9048 59.5294 19.2261C59.5294 21.5473 61.4294 23.4358 63.7647 23.4358C66.1 23.4358 68 21.5473 68 19.2261C68 16.9048 66.1 15.0163 63.7647 15.0163ZM63.7647 22.0326C62.2078 22.0326 60.9412 20.7736 60.9412 19.2261C60.9412 17.6786 62.2078 16.4196 63.7647 16.4196C65.3216 16.4196 66.5882 17.6786 66.5882 19.2261C66.5882 20.7736 65.3216 22.0326 63.7647 22.0326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5294 46.5895C9.58329 46.5895 8 48.1633 8 50.0977C8 52.0321 9.58329 53.6058 11.5294 53.6058C13.4755 53.6058 15.0588 52.0321 15.0588 50.0977C15.0588 48.1633 13.4755 46.5895 11.5294 46.5895ZM11.5294 52.2026C10.3616 52.2026 9.41176 51.2585 9.41176 50.0977C9.41176 48.9369 10.3616 47.9928 11.5294 47.9928C12.6971 47.9928 13.6471 48.9369 13.6471 50.0977C13.6471 51.2585 12.6971 52.2026 11.5294 52.2026Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7647 10.1049C58.3495 10.1049 58.8235 9.63369 58.8235 9.05244C58.8235 8.47119 58.3495 8 57.7647 8C57.1799 8 56.7059 8.47119 56.7059 9.05244C56.7059 9.63369 57.1799 10.1049 57.7647 10.1049Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5294 31.8553C66.1142 31.8553 66.5882 31.3842 66.5882 30.8029C66.5882 30.2217 66.1142 29.7505 65.5294 29.7505C64.9446 29.7505 64.4706 30.2217 64.4706 30.8029C64.4706 31.3842 64.9446 31.8553 65.5294 31.8553Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8823 49.396C60.4671 49.396 60.9412 48.9248 60.9412 48.3435C60.9412 47.7623 60.4671 47.2911 59.8823 47.2911C59.2976 47.2911 58.8235 47.7623 58.8235 48.3435C58.8235 48.9248 59.2976 49.396 59.8823 49.396Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1765 11.5082C11.7612 11.5082 12.2353 11.037 12.2353 10.4558C12.2353 9.87455 11.7612 9.40336 11.1765 9.40336C10.5917 9.40336 10.1176 9.87455 10.1176 10.4558C10.1176 11.037 10.5917 11.5082 11.1765 11.5082Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7059 32.5569C15.2907 32.5569 15.7647 32.0857 15.7647 31.5045C15.7647 30.9232 15.2907 30.452 14.7059 30.452C14.1211 30.452 13.6471 30.9232 13.6471 31.5045C13.6471 32.0857 14.1211 32.5569 14.7059 32.5569Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8824 66.2353C48.4671 66.2353 48.9412 65.7641 48.9412 65.1828C48.9412 64.6016 48.4671 64.1304 47.8824 64.1304C47.2976 64.1304 46.8235 64.6016 46.8235 65.1828C46.8235 65.7641 47.2976 66.2353 47.8824 66.2353Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9882 12.2099H47.4584C47.1304 10.6106 45.7044 9.40336 44 9.40336H31.2941C29.5897 9.40336 28.1637 10.6106 27.8357 12.2099H24.3059C21.9317 12.2099 20 14.1298 20 16.4898V57.0439C20 59.4038 21.9317 61.3239 24.3059 61.3239H50.9882C53.3624 61.3239 55.2941 59.4038 55.2941 57.0439V16.4898C55.2941 14.1298 53.3624 12.2099 50.9882 12.2099ZM31.2941 10.8066H44C45.1677 10.8066 46.1176 11.7509 46.1176 12.9115C46.1176 14.0721 45.1677 15.0164 44 15.0164H31.2941C30.1263 15.0164 29.1765 14.0721 29.1765 12.9115C29.1765 11.7509 30.1263 10.8066 31.2941 10.8066ZM53.8823 57.0439C53.8823 58.6302 52.5841 59.9206 50.9882 59.9206H24.3059C22.71 59.9206 21.4118 58.6302 21.4118 57.0439V16.4898C21.4118 14.9036 22.71 13.6131 24.3059 13.6131H27.8357C28.1637 15.2124 29.5897 16.4196 31.2941 16.4196H44C45.7044 16.4196 47.1304 15.2124 47.4584 13.6131H50.9882C52.5841 13.6131 53.8823 14.9036 53.8823 16.4898V57.0439Z",
    fill: "url(#paint0_linear_4132_28651)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7059 27.2949H35.5294V29.7506C35.5294 30.138 35.8454 30.4522 36.2353 30.4522H39.7647C40.1546 30.4522 40.4706 30.138 40.4706 29.7506V27.2949H43.2941C43.684 27.2949 44 26.9807 44 26.5932V23.0851C44 22.6976 43.684 22.3835 43.2941 22.3835H40.4706V19.9278C40.4706 19.5403 40.1546 19.2261 39.7647 19.2261H36.2353C35.8454 19.2261 35.5294 19.5403 35.5294 19.9278V22.3835H32.7059C32.316 22.3835 32 22.6976 32 23.0851V26.5932C32 26.9807 32.316 27.2949 32.7059 27.2949ZM33.4118 23.7867H36.2353C36.6252 23.7867 36.9412 23.4725 36.9412 23.0851V20.6294H39.0588V23.0851C39.0588 23.4725 39.3748 23.7867 39.7647 23.7867H42.5882V25.8916H39.7647C39.3748 25.8916 39.0588 26.2058 39.0588 26.5932V29.0489H36.9412V26.5932C36.9412 26.2058 36.6252 25.8916 36.2353 25.8916H33.4118V23.7867Z",
    fill: "url(#paint1_linear_4132_28651)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3529 35.3635H37.6471C38.037 35.3635 38.3529 35.0494 38.3529 34.6619C38.3529 34.2745 38.037 33.9603 37.6471 33.9603H26.3529C25.963 33.9603 25.6471 34.2745 25.6471 34.6619C25.6471 35.0494 25.963 35.3635 26.3529 35.3635Z",
    fill: "url(#paint2_linear_4132_28651)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 38.1701H26.3529C25.963 38.1701 25.6471 38.4842 25.6471 38.8717C25.6471 39.2593 25.963 39.5734 26.3529 39.5734H48.9412C49.3311 39.5734 49.6471 39.2593 49.6471 38.8717C49.6471 38.4842 49.3311 38.1701 48.9412 38.1701Z",
    fill: "url(#paint3_linear_4132_28651)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 42.3797H26.3529C25.963 42.3797 25.6471 42.6938 25.6471 43.0813C25.6471 43.4689 25.963 43.783 26.3529 43.783H48.9412C49.3311 43.783 49.6471 43.4689 49.6471 43.0813C49.6471 42.6938 49.3311 42.3797 48.9412 42.3797Z",
    fill: "url(#paint4_linear_4132_28651)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 46.5895H26.3529C25.963 46.5895 25.6471 46.9036 25.6471 47.2912C25.6471 47.6787 25.963 47.9928 26.3529 47.9928H48.9412C49.3311 47.9928 49.6471 47.6787 49.6471 47.2912C49.6471 46.9036 49.3311 46.5895 48.9412 46.5895Z",
    fill: "url(#paint5_linear_4132_28651)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 50.7994H26.3529C25.963 50.7994 25.6471 51.1134 25.6471 51.501C25.6471 51.8886 25.963 52.2026 26.3529 52.2026H48.9412C49.3311 52.2026 49.6471 51.8886 49.6471 51.501C49.6471 51.1134 49.3311 50.7994 48.9412 50.7994Z",
    fill: "url(#paint6_linear_4132_28651)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 55.0092H26.3529C25.963 55.0092 25.6471 55.3232 25.6471 55.7108C25.6471 56.0984 25.963 56.4125 26.3529 56.4125H48.9412C49.3311 56.4125 49.6471 56.0984 49.6471 55.7108C49.6471 55.3232 49.3311 55.0092 48.9412 55.0092Z",
    fill: "url(#paint7_linear_4132_28651)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7647 15.0163C61.4294 15.0163 59.5294 16.9048 59.5294 19.2261C59.5294 21.5473 61.4294 23.4358 63.7647 23.4358C66.1 23.4358 68 21.5473 68 19.2261C68 16.9048 66.1 15.0163 63.7647 15.0163ZM63.7647 22.0326C62.2078 22.0326 60.9412 20.7736 60.9412 19.2261C60.9412 17.6786 62.2078 16.4196 63.7647 16.4196C65.3216 16.4196 66.5882 17.6786 66.5882 19.2261C66.5882 20.7736 65.3216 22.0326 63.7647 22.0326Z",
    fill: "url(#paint8_linear_4132_28651)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5294 46.5895C9.58329 46.5895 8 48.1633 8 50.0977C8 52.0321 9.58329 53.6058 11.5294 53.6058C13.4755 53.6058 15.0588 52.0321 15.0588 50.0977C15.0588 48.1633 13.4755 46.5895 11.5294 46.5895ZM11.5294 52.2026C10.3616 52.2026 9.41176 51.2585 9.41176 50.0977C9.41176 48.9369 10.3616 47.9928 11.5294 47.9928C12.6971 47.9928 13.6471 48.9369 13.6471 50.0977C13.6471 51.2585 12.6971 52.2026 11.5294 52.2026Z",
    fill: "url(#paint9_linear_4132_28651)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7647 10.1049C58.3495 10.1049 58.8235 9.63369 58.8235 9.05244C58.8235 8.47119 58.3495 8 57.7647 8C57.1799 8 56.7059 8.47119 56.7059 9.05244C56.7059 9.63369 57.1799 10.1049 57.7647 10.1049Z",
    fill: "url(#paint10_linear_4132_28651)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5294 31.8553C66.1142 31.8553 66.5882 31.3842 66.5882 30.8029C66.5882 30.2217 66.1142 29.7505 65.5294 29.7505C64.9446 29.7505 64.4706 30.2217 64.4706 30.8029C64.4706 31.3842 64.9446 31.8553 65.5294 31.8553Z",
    fill: "url(#paint11_linear_4132_28651)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8823 49.396C60.4671 49.396 60.9412 48.9248 60.9412 48.3435C60.9412 47.7623 60.4671 47.2911 59.8823 47.2911C59.2976 47.2911 58.8235 47.7623 58.8235 48.3435C58.8235 48.9248 59.2976 49.396 59.8823 49.396Z",
    fill: "url(#paint12_linear_4132_28651)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1765 11.5082C11.7612 11.5082 12.2353 11.037 12.2353 10.4558C12.2353 9.87455 11.7612 9.40336 11.1765 9.40336C10.5917 9.40336 10.1176 9.87455 10.1176 10.4558C10.1176 11.037 10.5917 11.5082 11.1765 11.5082Z",
    fill: "url(#paint13_linear_4132_28651)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7059 32.5569C15.2907 32.5569 15.7647 32.0857 15.7647 31.5045C15.7647 30.9232 15.2907 30.452 14.7059 30.452C14.1211 30.452 13.6471 30.9232 13.6471 31.5045C13.6471 32.0857 14.1211 32.5569 14.7059 32.5569Z",
    fill: "url(#paint14_linear_4132_28651)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8824 66.2353C48.4671 66.2353 48.9412 65.7641 48.9412 65.1828C48.9412 64.6016 48.4671 64.1304 47.8824 64.1304C47.2976 64.1304 46.8235 64.6016 46.8235 65.1828C46.8235 65.7641 47.2976 66.2353 47.8824 66.2353Z",
    fill: "url(#paint15_linear_4132_28651)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9882 12.2099H47.4584C47.1304 10.6106 45.7044 9.40336 44 9.40336H31.2941C29.5897 9.40336 28.1637 10.6106 27.8357 12.2099H24.3059C21.9317 12.2099 20 14.1298 20 16.4898V57.0439C20 59.4038 21.9317 61.3239 24.3059 61.3239H50.9882C53.3624 61.3239 55.2941 59.4038 55.2941 57.0439V16.4898C55.2941 14.1298 53.3624 12.2099 50.9882 12.2099ZM31.2941 10.8066H44C45.1677 10.8066 46.1176 11.7509 46.1176 12.9115C46.1176 14.0721 45.1677 15.0164 44 15.0164H31.2941C30.1263 15.0164 29.1765 14.0721 29.1765 12.9115C29.1765 11.7509 30.1263 10.8066 31.2941 10.8066ZM53.8823 57.0439C53.8823 58.6302 52.5841 59.9206 50.9882 59.9206H24.3059C22.71 59.9206 21.4118 58.6302 21.4118 57.0439V16.4898C21.4118 14.9036 22.71 13.6131 24.3059 13.6131H27.8357C28.1637 15.2124 29.5897 16.4196 31.2941 16.4196H44C45.7044 16.4196 47.1304 15.2124 47.4584 13.6131H50.9882C52.5841 13.6131 53.8823 14.9036 53.8823 16.4898V57.0439Z",
    stroke: "url(#paint16_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7059 27.2949H35.5294V29.7506C35.5294 30.138 35.8454 30.4522 36.2353 30.4522H39.7647C40.1546 30.4522 40.4706 30.138 40.4706 29.7506V27.2949H43.2941C43.684 27.2949 44 26.9807 44 26.5932V23.0851C44 22.6976 43.684 22.3835 43.2941 22.3835H40.4706V19.9278C40.4706 19.5403 40.1546 19.2261 39.7647 19.2261H36.2353C35.8454 19.2261 35.5294 19.5403 35.5294 19.9278V22.3835H32.7059C32.316 22.3835 32 22.6976 32 23.0851V26.5932C32 26.9807 32.316 27.2949 32.7059 27.2949ZM33.4118 23.7867H36.2353C36.6252 23.7867 36.9412 23.4725 36.9412 23.0851V20.6294H39.0588V23.0851C39.0588 23.4725 39.3748 23.7867 39.7647 23.7867H42.5882V25.8916H39.7647C39.3748 25.8916 39.0588 26.2058 39.0588 26.5932V29.0489H36.9412V26.5932C36.9412 26.2058 36.6252 25.8916 36.2353 25.8916H33.4118V23.7867Z",
    stroke: "url(#paint17_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3529 35.3635H37.6471C38.037 35.3635 38.3529 35.0494 38.3529 34.6619C38.3529 34.2745 38.037 33.9603 37.6471 33.9603H26.3529C25.963 33.9603 25.6471 34.2745 25.6471 34.6619C25.6471 35.0494 25.963 35.3635 26.3529 35.3635Z",
    stroke: "url(#paint18_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 38.1701H26.3529C25.963 38.1701 25.6471 38.4842 25.6471 38.8717C25.6471 39.2593 25.963 39.5734 26.3529 39.5734H48.9412C49.3311 39.5734 49.6471 39.2593 49.6471 38.8717C49.6471 38.4842 49.3311 38.1701 48.9412 38.1701Z",
    stroke: "url(#paint19_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 42.3797H26.3529C25.963 42.3797 25.6471 42.6938 25.6471 43.0813C25.6471 43.4689 25.963 43.783 26.3529 43.783H48.9412C49.3311 43.783 49.6471 43.4689 49.6471 43.0813C49.6471 42.6938 49.3311 42.3797 48.9412 42.3797Z",
    stroke: "url(#paint20_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 46.5895H26.3529C25.963 46.5895 25.6471 46.9036 25.6471 47.2912C25.6471 47.6787 25.963 47.9928 26.3529 47.9928H48.9412C49.3311 47.9928 49.6471 47.6787 49.6471 47.2912C49.6471 46.9036 49.3311 46.5895 48.9412 46.5895Z",
    stroke: "url(#paint21_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 50.7994H26.3529C25.963 50.7994 25.6471 51.1134 25.6471 51.501C25.6471 51.8886 25.963 52.2026 26.3529 52.2026H48.9412C49.3311 52.2026 49.6471 51.8886 49.6471 51.501C49.6471 51.1134 49.3311 50.7994 48.9412 50.7994Z",
    stroke: "url(#paint22_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9412 55.0092H26.3529C25.963 55.0092 25.6471 55.3232 25.6471 55.7108C25.6471 56.0984 25.963 56.4125 26.3529 56.4125H48.9412C49.3311 56.4125 49.6471 56.0984 49.6471 55.7108C49.6471 55.3232 49.3311 55.0092 48.9412 55.0092Z",
    stroke: "url(#paint23_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7647 15.0163C61.4294 15.0163 59.5294 16.9048 59.5294 19.2261C59.5294 21.5473 61.4294 23.4358 63.7647 23.4358C66.1 23.4358 68 21.5473 68 19.2261C68 16.9048 66.1 15.0163 63.7647 15.0163ZM63.7647 22.0326C62.2078 22.0326 60.9412 20.7736 60.9412 19.2261C60.9412 17.6786 62.2078 16.4196 63.7647 16.4196C65.3216 16.4196 66.5882 17.6786 66.5882 19.2261C66.5882 20.7736 65.3216 22.0326 63.7647 22.0326Z",
    stroke: "url(#paint24_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5294 46.5895C9.58329 46.5895 8 48.1633 8 50.0977C8 52.0321 9.58329 53.6058 11.5294 53.6058C13.4755 53.6058 15.0588 52.0321 15.0588 50.0977C15.0588 48.1633 13.4755 46.5895 11.5294 46.5895ZM11.5294 52.2026C10.3616 52.2026 9.41176 51.2585 9.41176 50.0977C9.41176 48.9369 10.3616 47.9928 11.5294 47.9928C12.6971 47.9928 13.6471 48.9369 13.6471 50.0977C13.6471 51.2585 12.6971 52.2026 11.5294 52.2026Z",
    stroke: "url(#paint25_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7647 10.1049C58.3495 10.1049 58.8235 9.63369 58.8235 9.05244C58.8235 8.47119 58.3495 8 57.7647 8C57.1799 8 56.7059 8.47119 56.7059 9.05244C56.7059 9.63369 57.1799 10.1049 57.7647 10.1049Z",
    stroke: "url(#paint26_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5294 31.8553C66.1142 31.8553 66.5882 31.3842 66.5882 30.8029C66.5882 30.2217 66.1142 29.7505 65.5294 29.7505C64.9446 29.7505 64.4706 30.2217 64.4706 30.8029C64.4706 31.3842 64.9446 31.8553 65.5294 31.8553Z",
    stroke: "url(#paint27_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8823 49.396C60.4671 49.396 60.9412 48.9248 60.9412 48.3435C60.9412 47.7623 60.4671 47.2911 59.8823 47.2911C59.2976 47.2911 58.8235 47.7623 58.8235 48.3435C58.8235 48.9248 59.2976 49.396 59.8823 49.396Z",
    stroke: "url(#paint28_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1765 11.5082C11.7612 11.5082 12.2353 11.037 12.2353 10.4558C12.2353 9.87455 11.7612 9.40336 11.1765 9.40336C10.5917 9.40336 10.1176 9.87455 10.1176 10.4558C10.1176 11.037 10.5917 11.5082 11.1765 11.5082Z",
    stroke: "url(#paint29_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7059 32.5569C15.2907 32.5569 15.7647 32.0857 15.7647 31.5045C15.7647 30.9232 15.2907 30.452 14.7059 30.452C14.1211 30.452 13.6471 30.9232 13.6471 31.5045C13.6471 32.0857 14.1211 32.5569 14.7059 32.5569Z",
    stroke: "url(#paint30_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8824 66.2353C48.4671 66.2353 48.9412 65.7641 48.9412 65.1828C48.9412 64.6016 48.4671 64.1304 47.8824 64.1304C47.2976 64.1304 46.8235 64.6016 46.8235 65.1828C46.8235 65.7641 47.2976 66.2353 47.8824 66.2353Z",
    stroke: "url(#paint31_linear_4132_28651)",
    mask: "url(#path-1-outside-1_4132_28651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4132_28651",
    x1: 10.2649,
    y1: 6.43212,
    x2: 64.0759,
    y2: 69.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCard4);
export default __webpack_public_path__ + "static/media/auto_card4.836f7f2bda85b56a301ff3581957fd2a.svg";
export { ForwardRef as ReactComponent };